var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomerPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 25,
    viewBox: "0 0 40 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.1925,
    cy: 20.1923,
    r: 13.7821,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8718 0C8.8976 0 0 8.955 0 20C0 31.045 19.8718 50 19.8718 50C19.8718 50 39.7436 31.045 39.7436 20C39.7436 8.955 30.846 0 19.8718 0ZM27.3237 20V30H22.3558V22.5H17.3878V30H12.4199V20H7.45192L19.8718 10L32.2917 20H27.3237Z",
    fill: "#5F7941"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerPin);
export default __webpack_public_path__ + "static/media/customerPin.de97fcddc8e28435df5698387071664f.svg";
export { ForwardRef as ReactComponent };